"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OAuthController", {
    enumerable: true,
    get: function() {
        return OAuthController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _nocodbsdk = require("nocodb-sdk");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _models = require("~/models");
const _ncError = require("~/helpers/ncError");
const _globalguard = require("~/guards/global/global.guard");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _oauthauthorizationservice = require("~/modules/oauth/services/oauth-authorization.service");
const _oauthtokenservice = require("~/modules/oauth/services/oauth-token.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const logger = new _common.Logger('OAuthController');
let OAuthController = class OAuthController {
    async getOAuthClient(clientId) {
        const client = await _models.OAuthClient.getByClientId(clientId);
        if (!client) {
            _ncError.NcError.notFound('Oauth Client');
        }
        return client;
    }
    async authorizeRedirect(req, res) {
        const queryParams = new URLSearchParams(req.query).toString();
        const redirectUrl = `${req.ncSiteUrl}/#/oauth/authorize${queryParams ? '?' + queryParams : ''}`;
        return res.redirect(redirectUrl);
    }
    async authorize(body, req) {
        const { client_id, redirect_uri, state, approved, code_challenge, code_challenge_method, scope, workspace_id, base_id, resource } = body;
        if (!client_id || !redirect_uri) {
            _ncError.NcError.badRequest('Missing required parameters: client_id, redirect_uri');
        }
        try {
            if (!approved) {
                const errorRedirectUrl = this.oauthAuthorizationService.buildRedirectUrl(redirect_uri, _extends({
                    error: 'access_denied',
                    error_description: 'User denied the request'
                }, state && {
                    state
                }));
                return {
                    redirect_url: errorRedirectUrl
                };
            }
            const authCode = await this.oauthAuthorizationService.createAuthorizationCode({
                clientId: client_id,
                userId: req.user.id,
                redirectUri: redirect_uri,
                state,
                codeChallenge: code_challenge,
                codeChallengeMethod: code_challenge_method,
                scope,
                workspaceId: workspace_id,
                baseId: base_id,
                resource
            });
            const successRedirectUrl = this.oauthAuthorizationService.buildRedirectUrl(redirect_uri, _extends({
                code: authCode.code
            }, state && {
                state
            }));
            return {
                redirect_url: successRedirectUrl
            };
        } catch (e) {
            logger.error(e == null ? void 0 : e.message, e);
            const errorRedirectUrl = this.oauthAuthorizationService.buildRedirectUrl(redirect_uri, _extends({
                error: 'server_error',
                error_description: 'Authorization server encountered an error'
            }, state && {
                state
            }));
            return {
                redirect_url: errorRedirectUrl
            };
        }
    }
    async token(body, contentType, res) {
        if (!contentType || !contentType.includes('application/x-www-form-urlencoded')) {
            return res.status(400).json({
                error: 'invalid_request',
                error_description: 'Content-Type must be application/x-www-form-urlencoded'
            });
        }
        const { grant_type, code, redirect_uri, code_verifier, refresh_token, resource, client_id: clientId, client_secret: clientSecret } = body;
        if (!grant_type) {
            return res.status(400).json({
                error: 'invalid_request',
                error_description: 'Missing required parameter: grant_type'
            });
        }
        try {
            let result;
            switch(grant_type){
                case 'authorization_code':
                    if (!code || !redirect_uri) {
                        return res.status(400).json({
                            error: 'invalid_request',
                            error_description: 'Missing required parameters: code, redirect_uri'
                        });
                    }
                    if (!code_verifier) {
                        return res.status(400).json({
                            error: 'invalid_request',
                            error_description: 'Missing required parameter: code_verifier'
                        });
                    }
                    result = await this.oauthTokenService.exchangeCodeForTokens({
                        code,
                        redirectUri: redirect_uri,
                        codeVerifier: code_verifier,
                        clientSecret,
                        resource
                    });
                    return res.status(200).json(result);
                case 'refresh_token':
                    if (!refresh_token) {
                        return res.status(400).json({
                            error: 'invalid_request',
                            error_description: 'Missing required parameter: refresh_token'
                        });
                    }
                    if (!clientId && !clientSecret) {
                        return res.status(400).json({
                            error: 'invalid_request',
                            error_description: 'Missing required parameter: client_id'
                        });
                    }
                    result = await this.oauthTokenService.refreshAccessToken({
                        refreshToken: refresh_token,
                        clientId,
                        clientSecret,
                        resource
                    });
                    return res.status(200).json(result);
                default:
                    return res.status(400).json({
                        error: 'unsupported_grant_type',
                        error_description: `Unsupported grant_type: ${grant_type}`
                    });
            }
        } catch (error) {
            var _error_message, _error_message1, _error_message2, _error_message3, _error_message4, _error_message5, _error_message6, _error_message7, _error_message8, _error_message9;
            if ((_error_message = error.message) == null ? void 0 : _error_message.startsWith('invalid_client:')) {
                return res.status(401).json({
                    error: 'invalid_client',
                    error_description: error.message.replace('invalid_client: ', '')
                });
            }
            if ((_error_message1 = error.message) == null ? void 0 : _error_message1.startsWith('invalid_grant:')) {
                return res.status(400).json({
                    error: 'invalid_grant',
                    error_description: error.message.replace('invalid_grant: ', '')
                });
            }
            if ((_error_message2 = error.message) == null ? void 0 : _error_message2.startsWith('invalid_request:')) {
                return res.status(400).json({
                    error: 'invalid_request',
                    error_description: error.message.replace('invalid_request: ', '')
                });
            }
            if (error.message === 'invalid_client') {
                return res.status(401).json({
                    error: 'invalid_client',
                    error_description: 'Client authentication failed'
                });
            }
            if (error.message === 'invalid_grant') {
                return res.status(400).json({
                    error: 'invalid_grant',
                    error_description: 'The provided authorization grant is invalid'
                });
            }
            if (((_error_message3 = error.message) == null ? void 0 : _error_message3.includes('revoked')) || ((_error_message4 = error.message) == null ? void 0 : _error_message4.includes('expired')) || ((_error_message5 = error.message) == null ? void 0 : _error_message5.includes('Invalid refresh token')) || ((_error_message6 = error.message) == null ? void 0 : _error_message6.includes('Invalid authorization code')) || ((_error_message7 = error.message) == null ? void 0 : _error_message7.includes('PKCE'))) {
                return res.status(400).json({
                    error: 'invalid_grant',
                    error_description: error.message || 'The provided authorization grant is invalid'
                });
            }
            if (((_error_message8 = error.message) == null ? void 0 : _error_message8.includes('client_id')) || ((_error_message9 = error.message) == null ? void 0 : _error_message9.includes('redirect_uri'))) {
                return res.status(400).json({
                    error: 'invalid_request',
                    error_description: error.message || 'Invalid request parameters'
                });
            }
            logger.error('oauth_token_error', error);
            return res.status(500).json({
                error: 'server_error',
                error_description: 'An unexpected error occurred'
            });
        }
    }
    async revoke(body, contentType) {
        if (!contentType || !contentType.includes('application/x-www-form-urlencoded')) {
            return {
                error: 'invalid_request',
                error_description: 'Content-Type must be application/x-www-form-urlencoded'
            };
        }
        const { token, token_type_hint } = body;
        const { client_id: clientId, client_secret: clientSecret } = body;
        if (!token || !clientId) {
            return {
                error: 'invalid_request',
                error_description: 'Missing required parameters: token, client_id'
            };
        }
        try {
            await this.oauthTokenService.revokeToken({
                token,
                clientId,
                clientSecret,
                tokenTypeHint: token_type_hint
            });
            return {
                success: true
            };
        } catch (error) {
            if (error.message === 'invalid_client') {
                return {
                    error: 'invalid_client',
                    error_description: 'Client authentication failed'
                };
            }
            return {
                error: 'invalid_request',
                error_description: error.message || 'Token revocation failed'
            };
        }
    }
    constructor(oauthAuthorizationService, oauthTokenService){
        this.oauthAuthorizationService = oauthAuthorizationService;
        this.oauthTokenService = oauthTokenService;
    }
};
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Get)([
        '/api/v2/public/oauth/client/:clientId'
    ]),
    _ts_param(0, (0, _common.Param)('clientId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OAuthController.prototype, "getOAuthClient", null);
_ts_decorate([
    (0, _common.Get)('/api/v2/oauth/authorize'),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], OAuthController.prototype, "authorizeRedirect", null);
_ts_decorate([
    (0, _common.Post)('/api/v2/oauth/authorize'),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], OAuthController.prototype, "authorize", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Post)([
        '/api/v2/oauth/token'
    ]),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Headers)('content-type')),
    _ts_param(2, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        String,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], OAuthController.prototype, "token", null);
_ts_decorate([
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.Post)([
        '/api/v2/oauth/revoke'
    ]),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Headers)('content-type')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OAuthController.prototype, "revoke", null);
OAuthController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _oauthauthorizationservice.OauthAuthorizationService === "undefined" ? Object : _oauthauthorizationservice.OauthAuthorizationService,
        typeof _oauthtokenservice.OauthTokenService === "undefined" ? Object : _oauthtokenservice.OauthTokenService
    ])
], OAuthController);
